import { render, staticRenderFns } from "./dept_list.vue?vue&type=template&id=075c0ffa&scoped=true"
import script from "./dept_list.vue?vue&type=script&lang=js"
export * from "./dept_list.vue?vue&type=script&lang=js"
import style0 from "./dept_list.vue?vue&type=style&index=0&id=075c0ffa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075c0ffa",
  null
  
)

export default component.exports